function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.82 14.32c-.09.48-.5.82-.98.82H9.3c-.66 0-1.14-.64-.96-1.27l.84-2.95-1.71.34c-.05.01-.1.01-.15.01a.748.748 0 01-.14-1.48l2.47-.49 1.31-4.57c.06-.21.26-.36.48-.36h1.36a1 1 0 01.97 1.26l-.81 3.01 1.93-.39a.75.75 0 11.29 1.47l-2.66.53-.55 2.05H15c.62 0 1.09.56.98 1.18l-.16.84z"
})));